import React from "react"
import ContentLoader from "react-content-loader"

const SkeletonContent = (props) => (
    <ContentLoader
        speed={2}
        width={250}
        height={470}
        viewBox="0 0 250 470"
        backgroundColor="#1a1e1f"
        foregroundColor="#999999"
        {...props}
    >
        <rect x="1" y="1" rx="15" ry="15" width="246" height="467" />
    </ContentLoader>
)

export default SkeletonContent;